module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"continue":"Continue","pending":{"title":"Pending Challenger","subtitle":"We will notify you when the challenge is accepted"}},"en":{"continue":"Continue","pending":{"title":"Pending Challenger","subtitle":"We will notify you when the challenge is accepted"}}}')
  delete Component.options._Ctor
}
